import { map } from 'rxjs/operators';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Workflow, Actions, WorkflowType } from '../../../../models';
import {
  WorkflowContextService,
  WorkflowService,
  SecurityService
} from '../../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';

@Component({
  selector: 'wm-workflow-list-view',
  templateUrl: './workflow-list-view.component.html',
  styleUrls: ['./workflow-list-view.component.css'],
  standalone: false
})
export class WorkflowListViewComponent implements OnInit, OnDestroy {
  @Input() isTemplateLibrary: boolean = false;

  workflows: Workflow[];
  archivedWorkflows: Workflow[];
  loadGlobal = false;
  clientSub: Subscription;
  canCreateWorkflow: boolean;
  canCreateFromTemplate: boolean;
  workflowTypes: WorkflowType[] = [];

  isSysAdmin = false;

  ngOnDestroy() {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
    }
  }

  constructor(
    public _context: WorkflowContextService,
    private _workflowSvc: WorkflowService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _securitySvc: SecurityService
  ) {}

  _loadWorkflows() {
    return this._workflowSvc
      .getWorkflows(
        this._context.client,
        false,
        this.loadGlobal,
        this.workflowTypes
      )
      .pipe(
        map(res => {
          this.workflows = res;
        })
      );
  }
  _loadArchivedWorkflows() {
    return this._workflowSvc
      .getWorkflows(
        this._context.client,
        true,
        this.loadGlobal,
        this.workflowTypes
      )
      .subscribe(res => {
        this.archivedWorkflows = res.filter(w => w.isArchived);
      });
  }

  loadWorkflows() {
    this._loadWorkflows().subscribe(() => {
      this._loadArchivedWorkflows();
    });
  }

  createWorkflow() {
    this._router.navigate(
      this.loadGlobal
        ? ['admin', 'global', 'workflows', 'add']
        : ['admin', 'jurisdiction', this._context.client.id, 'workflows', 'add']
    );
  }

  isSystemAdmin() {
    this._securitySvc.isSystemAdministrator().subscribe(result => {
      this.isSysAdmin = result;
    });
  }

  restoreWorkflow(e) {
    this.loadWorkflows();
  }

  copyWorkflow(e) {
    this.loadWorkflows();
  }

  enableWorkflow(e) {
    const wf = this.workflows.find(w => w.id == e);

    if (wf) {
      wf.isEnabled = true;
    }
  }

  disableWorkflow(e) {
    const wf = this.workflows.find(w => w.id == e);

    if (wf) {
      wf.isEnabled = false;
    }
  }

  publishWorkflow(e) {
    this.loadWorkflows();
  }

  restoreCheckpoint(e) {
    this.loadWorkflows();
  }

  archiveWorkflow(e) {
    this.loadWorkflows();
  }

  init() {
    this._securitySvc
      .isLoginEntitled(Actions.WORKFLOW_ADD)
      .subscribe(result => {
        this.canCreateWorkflow = result;
      });

    // check if the user can create a workflow from a template
    this._securitySvc
      .isLoginEntitled(Actions.NEW_WORKFLOW_FROM_TEMPLATE)
      .subscribe(result => {
        this.canCreateFromTemplate = result;
      });

    this.loadWorkflows();
  }

  ngOnInit() {
    this.isSystemAdmin();

    this._route.data.subscribe(d => {
      this.loadGlobal = d.loadGlobal;

      this.workflowTypes =
        !this.loadGlobal || this.isTemplateLibrary
          ? [
              WorkflowType.Permit,
              WorkflowType.Other,
              WorkflowType.Renewable,
              WorkflowType.MobileInspection
            ]
          : [
              WorkflowType.ContractorRegistration,
              WorkflowType.ContractorRenewal
            ];

      if ((this._context && this._context.client) || this.loadGlobal) {
        this.init();
      } else {
        this.clientSub = this._context.client$.subscribe(() => {
          if (this._context.client) {
            this.init();
          }
        });
      }
    });
  }
}
